<template lang="pug">
modal#qualified-signature-execute-plugin-modal(
  :no-footer='true'
  :title='$t("modal.qualifiedSignatureCertificatePluginModal.title")'
  ref='modal'
  size='sm'
)
  p(
    v-html='$t("modal.qualifiedSignatureCertificatePluginModal.messageExecute1")'
  )
  .my-3.text-center
    .text-center.my-4
      img.img-fluid(src='/img/ilustrations/laptop-executing.svg')
    .text-start.my-4
      p {{ $t('modal.qualifiedSignatureCertificatePluginModal.messageExecute2') }}
      p {{ $t('modal.qualifiedSignatureCertificatePluginModal.messageExecute3') }}
  .modal-actions.mt-5
    .executing-plugin.form-check
      input#executing-plugin.executing-plugin__input.form-check-input(
        :checked='isExecutingPlugin'
        @change='toggleExecutePlugin'
        type='checkbox'
      )
      label.executing-plugin__label.form-check-label(for='executing-plugin') {{ $t('modal.qualifiedSignatureCertificatePluginModal.checkboxMessage') }}
    button.btn.btn-primary.ms-4(
      :disabled='disabledNext'
      @click='close'
      style='border-width: 1px'
      type='button'
    ) {{ $t('modal.envelope.next') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'QualifiedSignatureExecutePluginModal',
  components: {
    Icon,
    Modal,
  },
  data() {
    return {
      osInfo: '',
      isExecutingPlugin: false,
      disabledNext: true,
    };
  },
  methods: {
    close() {
      this.$refs.modal.close();
      this.$emit('close');
    },
    toggleExecutePlugin(event) {
      this.isExecutingPlugin = event.target.checked;
      this.disabledNext = !event.target.checked;
    },
  },
};
</script>
<style scoped>
.modal-actions {
  display: flex;
  align-items: center;
  width: 100%;
}

.executing-plugin {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
}

.executing-plugin__label {
  font-size: 14px;
  color: #666;
}

.executing-plugin__input {
  margin-top: 0;
  accent-color: #666;
}

.executing-plugin__input:checked {
  background-color: #666 !important;
  border-color: #666 !important;
}

.modal-actions .btn {
  margin-left: auto;
}
</style>
